import { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCredentialData, useThemeContext } from '../../contexts';
import FooterButton from './FooterButton';
import NavWalletIcon from '../Icons/NavWalletIcon';
import NavOfferIcon from '../Icons/NavOfferIcon';
import NavWalletRequestIcon from '../Icons/NavWalletRequestIcon';
import { getResponsivePadding } from '../../helpers/utils';

/**
 * Footer component with responsive design
 *
 * @param {PropsWithChildren} props
 * @return {React.FC}
 */
const Footer: React.FC<PropsWithChildren> = () => {
  const { offers, proofs } = useCredentialData();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { theme } = useThemeContext();

  const styles = StyleSheet.create({
    footerStyle: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.primary,
      backgroundColor: theme.layoutBackground,
      bottom: 0,
      paddingHorizontal: getResponsivePadding(4, 8, 12),
      paddingVertical: getResponsivePadding(4, 6, 8)
    }
  });

  return (
    <View style={styles.footerStyle}>
      <FooterButton
        onPress={() => navigate('/')}
        title={'WALLET'}
        icon={<NavWalletIcon />}
        isActive={pathname === '/'}></FooterButton>
      <FooterButton
        onPress={() => navigate('/offers')}
        title="OFFERS"
        icon={<NavOfferIcon />}
        isActive={pathname === '/offers'}
        jiggle={offers?.length > 0 && pathname !== '/offers'}
        badgeCount={pathname !== '/offers' ? offers.length : 0}></FooterButton>
      <FooterButton
        onPress={() => navigate('/proof-requests')}
        title="REQUESTS"
        icon={<NavWalletRequestIcon />}
        isActive={pathname === '/proof-requests'}
        jiggle={proofs?.length > 0 && pathname !== '/proof-requests'}
        badgeCount={pathname !== '/proof-request' ? proofs.length : 0}></FooterButton>
    </View>
  );
};

export default Footer;
